import { useEffect, useState } from "react";

// Возвращает true после первой прокрутки страницы.
// Нужен, чтобы плавающие элементы (панель мессенджеров, виджет рейтинга)
// не закрывали первый экран при входе на сайт.
export default function useHasScrolled(threshold = 1) {
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const isScrolled = () =>
      (window.scrollY ?? document.documentElement.scrollTop) > threshold;

    // страница могла открыться уже прокрученной (возврат по истории, якорь)
    if (isScrolled()) {
      setHasScrolled(true);
      return undefined;
    }

    const handleScroll = () => {
      if (isScrolled()) {
        setHasScrolled(true);
        window.removeEventListener("scroll", handleScroll);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [threshold]);

  return hasScrolled;
}
